import React from 'react';
import styled from 'styled-components';
import { Clinic } from 'kb-shared';
import { location as locationIcon } from '../../../assets/icons';

interface Props {
  location: Clinic;
}

const LocationDetails = ({ location }: Props) => {
  return (
    <CondensedFlexWrapper>
      <img src={locationIcon} alt="location icon" />
      <LocationWrapper>
        <LocationName>{location.name}</LocationName>
        <LocationAddress>{location.address}</LocationAddress>
      </LocationWrapper>
    </CondensedFlexWrapper>
  );
};

export default LocationDetails;

const LocationName = styled.h4`
  margin: 0;
`;

const LocationAddress = styled.p`
  margin: 0;
`;

const LocationWrapper = styled.div`
  margin-left: 12px;
`;

const CondensedFlexWrapper = styled.div`
  display: flex;
`;
